import { useState } from 'react';
import { useRouter } from '@tanstack/react-router';
import { formatDate, getMonthToDateRange } from '@/utils/date';

interface UseEmployeeReportPageParams {
  dateFrom: string | undefined;
  dateTo: string | undefined;
}

export function useEmployeeReportPage({ dateFrom, dateTo }: UseEmployeeReportPageParams) {
  const router = useRouter();
  const defaults = getMonthToDateRange();
  const today = formatDate(new Date());

  const [currentDateFrom, setDateFrom] = useState(dateFrom ?? defaults.dateFrom);
  const [currentDateTo, setDateTo] = useState(dateTo ?? defaults.dateTo);

  function setCurrentDateFrom(next: string) {
    setDateFrom(next);
    if (next > currentDateTo) setDateTo(next);
  }

  function setCurrentDateTo(next: string) {
    setDateTo(next);
    if (next < currentDateFrom) setDateFrom(next);
  }

  function handleBack() {
    router.history.back();
  }

  return {
    currentDateFrom,
    setCurrentDateFrom,
    currentDateTo,
    setCurrentDateTo,
    today,
    handleBack,
  };
}
